/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { TableCell, TableRow } from "@material-ui/core";

import { Text } from "UpduoLibrary";
import { skaleBlack } from "config/UpduoColors";
import { GetUserproxiesListQuery } from "graphql/internal/generated";
import { NodeType } from "config/UtilityTypes";

interface MemberProxyRowProps {
  rowData: NodeType<GetUserproxiesListQuery, "staffUserproxies">;
  userIndex: number;
}

export default function MemberProxyRow({
  rowData,
  userIndex,
}: MemberProxyRowProps) {
  const additionalColumnTitleArray = [
    rowData.title ? rowData.title : "-",
    rowData.internalId ? rowData.internalId : "-",
    rowData.email ? rowData.email : "-",
    rowData.region ? rowData.region.name : "-",
    rowData.district ? rowData.district.name : "-",
    rowData.store ? rowData.store.name : "-",
    rowData.hireDate ? rowData.hireDate : "-",
  ];

  const additionalColumnHeaders = additionalColumnTitleArray.map(
    (item, itemIndex) => (
      <TableCell key={itemIndex + 3}>
        <Text style={{ color: skaleBlack }}>{item}</Text>
      </TableCell>
    )
  );

  return (
    <TableRow hover={true} key={0}>
      <TableCell key={0} align={"center"}>
        <View>
          <Text style={{ color: skaleBlack, fontSize: 12 }}>
            {userIndex + 1}
          </Text>
        </View>
      </TableCell>
      <TableCell key={1}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text>{`${rowData.firstName} ${rowData.lastName}`}</Text>
        </View>
      </TableCell>
      {additionalColumnHeaders}
    </TableRow>
  );
}
